"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.policyPercentageCellRenderer = void 0;
const react_1 = __importDefault(require("react"));
require("../../../../../../components");
const widgets_1 = require("../../..");
require("../../TopPoliciesDataGridModel");
function policyPercentageCellRenderer(configProps = {}) {
    return (cellRendererProps) => {
        var _a;
        const { value, delta } = (_a = cellRendererProps.cellData) !== null && _a !== void 0 ? _a : {};
        return (react_1.default.createElement(widgets_1.PercentageTooltipText, Object.assign({ value: value, delta: delta }, cellRendererProps, configProps)));
    };
}
exports.policyPercentageCellRenderer = policyPercentageCellRenderer;
//# sourceMappingURL=policyPercentageCellRenderer.js.map